<template>
  <span class="sortable" @click.prevent="handleClick">
    {{ title }}
    <span v-if="field === query.sort">
      {{order === 'asc' ? '&uarr;' : '&darr;'}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'thSort',
  props: {
    title: { type: String, required: true },
    field: { type: String, required: true },
    query: { type: Object, required: true }
  },
  data: () => ({
    order: ''
  }),
  watch: {
    query: {
      handler({ sort: field, order }) {
        this.order = field === this.field ? order : '';
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClick() {
      const { query, order } = this;
      query.sort = this.field;
      query.order = this.order = order === 'desc' ? 'asc' : 'desc';
    }
  }
};
</script>

<style scoped>
.sortable {
  color: #428bca;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTable/components/thSortable.vue